// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__if09o","box":"WorkspacesBox_box__XFncH","node":"WorkspacesBox_node__dCp4E"};